var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.pdfUrl,"width":"100%","height":"800px","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }